<script>
import lazyLoadComponent from '@router/lazyload-component'

function initData() {
  return {
    storeIds: [],
    serviceCategoryIds: [],
    productPriceIds: [],
    maxCollision: 1
  }
}
export default {
  components: {
    ServiceTree: () => lazyLoadComponent(import("../ServiceTree.vue")),
  },
  props: {
    defaultValue: {
      type: Object,
      default: () => { },
    },
    value: {
      type: Object,
      default: () => { }
    },
  },
  data() {
    return {
      // submitData: {
      //   storeIds: [],
      //   serviceCategoryIds: [],
      //   productPriceIds: [],
      //   // maxCollision: 0
      // },
      petCategoryList: {}, // 寵物類別名稱
      categoryList: [],
      priceList: [],
      locations: [],
      catchPruducts: [], // 選擇到的分店
      catchPrices: [], // 選擇到的服務項目
      checkAll: false,
      checkAllCategory: false,
      productsDialogVisible: false, // 新增適用分店 跳窗 開啟/關閉
      pricesDialogVisible: false, // 新增適用服務項目 跳窗 開啟/關閉
      prepaidsDialogVisible: false, // 適用包月方案 跳窗開啟/關閉
      serviceTypeOptions: [{
        value: 'cosmetic',
        label: '美容'
      }],
    }
  },
  computed: {
    submitData: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    serviceTreeRenderStatus() {
      if (this.locations.length > 0 && this.categoryList.length > 0) {
        return true
      } else {
        return false
      }
    },
    isEditMode() {
      return this.defaultValue.id !== undefined
    },
    availableService() {
      let list = []
      this.priceList.forEach((serviceItem) => {
        // this.submitData.storeIds.forEach((product) => {
        // if (serviceItem.productId === product.id) {
        // this.submitData.serviceCategoryIds.forEach((category) => {
        //   if (serviceItem.petSizeId === category) {
        //     list.push({
        //       ...serviceItem,
        //       location: product.name,
        //     })
        //   }
        // })
        // }
        // })
        serviceItem.title = `${serviceItem.title} (${serviceItem.petCategoryTitle})`
        list.push(serviceItem)
      })
      // const listSet = new Set(list.map(data => data));
      // const arr = Array.from(listSet)
      return list
    },
    isIndeterminate() {
      this.checkAll = this.submitData.productPriceIds.length === this.availableService.length
      if (this.submitData.productPriceIds.length === 0) return false
      return this.submitData.productPriceIds.length > 0 && this.submitData.productPriceIds.length < this.availableService.length
    },
    isIndeterminateCategory() {
      this.checkAllCategory = this.submitData.serviceCategoryIds.length === this.categoryList.length
      if (this.submitData.serviceCategoryIds.length === 0) return false
      return this.submitData.serviceCategoryIds.length > 0 && this.submitData.serviceCategoryIds.length < this.categoryList.length
    },
    filterSubmitData() {
      const storeIds = this.submitData.storeIds.map((item) => item.id)
      return {
        ...this.submitData,
        storeIds,
      }
    },
    submitRules() {
      return {
        maxCollision: [
          {
            required: true,
            message: '請輸入人數',
            trigger: 'blur',
            type: 'number',
            min: 0,
          },
        ],
        storeIds: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value.length) {
                this.$nextTick(() => {
                  this.$refs.form.clearValidate('productPriceIds')
                })
                return
              }
              callback()
            },
            trigger: 'change',
          },
        ],
        productPriceIds: [
          {
            required: true,
            message: '請選擇服務項目',
            trigger: 'change',
          },
        ],
        serviceCategoryIds: [
          {
            required: true,
            message: `請選擇${this.$t('reserve.CLIENT')}類別或${this.$t('member.BODY_TO_TYPE')}`,
            trigger: 'change',
          },
        ],
      }
    },
  },
  watch: {
    // "defaultValue.maxCollision": {
    //   handler(nvl, ovl) {
    //     this.$set(this.submitData, 'maxCollision', +nvl)
    //   }
    // }
  },
  async created() {
    await this.tryToFetchService()
    await this.getDefaultSubmitData()
  },
  mounted() {
    // 未來安親模組
    if (this.$hasDayCare()) {
      this.serviceTypeOptions.push(
        {
          value: 'daycare',
          label: '安親'
        }
      )
    }
  },
  methods: {
    async getDefaultSubmitData() {
      await this.tryToSearchProduct()
      let categoryAll = await this.$store.dispatch('product/fetchServiceCategory', {paginate: 0})
      let newArray = []
      categoryAll.forEach((itemParent) => {
        itemParent.children.forEach((item) => {
          newArray.push(item)
        })
      })
      this.categoryList = newArray
      if (this.isEditMode) {
        const { storeIds, serviceCategoryIds, productPriceIds, maxCollision } = this.defaultValue
        this.submitData = {
          ...this.submitData,
          storeIds: this.locations.filter((location) => storeIds.includes(location.id)),
          serviceCategoryIds,
          productPriceIds,
          maxCollision
        }
      } else {
        this.submitData = {
          ...this.submitData,
          storeIds: [],
          serviceCategoryIds: [],
          productPriceIds: [],
          maxCollision: 1
        }
      }
    },
    async tryToFetchService() {
      this.$emit('loadingStatus', true)
      const { items } = await this.$store.dispatch('product/fetchNormalServiceData', {
        types: this.defaultValue.types ?? ['cosmetic', 'daycare'],
        paginate: 0
      })
      this.$emit('loadingStatus', false)
      this.priceList = items
    },
    async tryToSearchProduct() {
      const { items } = await this.$store.dispatch('product/fetchList', { limit: 10000, page: 1, paginate: 0 })
      this.locations = items
    },
    onLocationChange(selectedItem) {
      this.checkValidServices()
    },
    checkValidServices() {
      const storeIds = this.submitData.storeIds.map((product) => product.id)
      const validPrice = this.priceList.filter((price) => storeIds.includes(price.productId)).map((price) => price.id)
      this.submitData.productPriceIds = [...this.submitData.productPriceIds.filter((serviceId) => validPrice.includes(serviceId))]
    },
    handleCheckAllChange(checked) {
      this.submitData.productPriceIds = checked ? this.availableService.map((price) => price.id) : []
    },
    handleCheckAllCategory(checked) {
      this.submitData.serviceCategoryIds = checked ? this.categoryList.map((category) => category.id) : []
    },
    validateServiceTree() {
      return this.$refs.serviceTree.validateSelf()
    },
    validate() {
      return this.$refs.form.validate()
    },
    creatAvaliablePrices() {
      this.pricesDialogVisible = true
    },
    creatAvaliableProdects() {
      this.productsDialogVisible = true
    },
    creatAvaliablePrepaids() {
      this.prepaidsDialogVisible = true
    },

    cancelSelectPrices() {
      this.pricesDialogVisible = false
    },
    cancelSelectProducts() {
      this.productsDialogVisible = false
    },
    cancelSelectPrepaids() {
      this.prepaidsDialogVisible = false
    },
  },
}
</script>

<template>
  <div :class="$style.thisPagePadding">
    <el-form ref="form" :model="submitData" :rules="submitRules" label-position="top">
      <div :class="$style.titlePadding">
        <h4 style="margin-top:0;margin-bottom:0"> 服務項目 </h4>
        <el-form-item label="可同時服務幾位顧客" prop="maxCollision">
          <el-input v-model.number="submitData.maxCollision" class="bg-white is-border" />
        </el-form-item>
        <el-form-item label="可服務的服務類型" prop="maxCollision">
          <el-select v-model="submitData.types" multiple placeholder="請選擇">
            <el-option v-for="item in serviceTypeOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </div>
      <ServiceTree ref="serviceTree" v-model="submitData" :locations.sync="locations" :default-value="defaultValue" />
    </el-form>
  </div>
</template>
<style lang="scss" module>
.repeat {
  :global {
    .el-checkbox-button {
      .el-checkbox-button__inner {
        border-radius: 8px;
        padding: 14px 15px;
        border-color: $color-primary;
      }

      &.is-checked {
        .el-checkbox-button__inner {
          background: $color-primary;
        }
      }

      &+.el-checkbox-button {
        margin-left: 5px;

        .el-checkbox-button__inner {
          border-left: 1px solid $color-primary;
        }
      }
    }
  }
}

.services-wrap {
  margin: 0 -5px 30px;
}

.services {
  :global {
    label.el-checkbox.is-bordered {
      width: calc(50% - 10px);
      display: inline-flex;
      margin: 5px;
      align-items: center;
      height: auto;
      padding: 15px 20px 15px 15px;

      @include max-sm {
        width: 100%;
      }

      .el-checkbox__inner {
        border-radius: 10px;
        width: 18px;
        height: 18px;

        &:after {
          left: 5px;
          top: 2px;
          height: 8px;
          width: 4px;
          border-width: 2px;
        }
      }

      .el-checkbox__label {
        padding-left: 15px;
        width: 100%;
      }

      &+.el-checkbox.is-bordered {
        margin-left: 5px;
      }

      .title,
      .meta {
        width: calc(100% - 20px);
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
      }

      .content {
        width: 100%;
      }
    }
  }
}

.footer {
  display: flex;

  :global {
    button {
      flex: 1 0 auto;
    }
  }
}

.thisPagePadding {
  padding: 2rem 2rem 6rem;
}

.box {
  background-color: #f9f9f9;
  border: $color-border-light 1px solid;
  padding: 15px;
  border-radius: 6px;

  :global {
    .inner-box {
      margin-bottom: 20px;
      height: calc(100vh - 380px);
      overflow-y: scroll;
    }

    .box {
      &__title {
        white-space: normal;
        text-align: left;
        line-height: 1.4;
        max-width: calc(100% - 100px);
      }
    }

    .el-checkbox-group {
      display: flex;
      flex-wrap: wrap;
    }

    .el-checkbox.is-bordered {
      background-color: #fff;

      .el-checkbox__label {
        white-space: normal;
      }
    }

    .search-in-box {
      .el-input__inner {
        background-color: #fff;
        margin-left: 5px;
        margin-right: 5px;
        margin-bottom: 10px;
      }
    }

    .input-in-buttom {
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;
    }

    .el-form-item {
      margin-bottom: 15px;
    }

    .el-button {
      .el-input {
        width: 100px;
      }

      .el-input__inner {
        background-color: #fff;
        border-color: $color-border-base;
        height: 30px;

        &:focus {
          // border-color: $color-primary;
        }
      }

      .el-input__suffix {
        top: 7px;
      }
    }

    .inline-section {
      display: flex;
      margin-bottom: 15px;
    }

    .el-button.is-no-border {
      border: 0;
    }
  }
}
</style>
<!-- <template> -->
      <!-- 舊下拉，未來不用p1 -->
      <!-- <el-form-item label="設定此時段可服務的地點" prop="storeIds">
        <el-select v-model="submitData.storeIds" value-key="id" multiple placeholder="請選擇" :popper-append-to-body="true" @change="onLocationChange">
          <el-option v-for="site in locations" :key="site.id" :label="site.name" :value="site"> </el-option>
        </el-select>
      </el-form-item> -->


      <!-- 舊下拉，未來不用p2 -->
      <!-- <el-form-item v-if="categoryList.length > 0" prop="serviceCategoryIds">
        <span slot="label" class="clickOk"
          >此時段可服務的寵物類別與體型 <el-checkbox v-model="checkAllCategory" class="check-by-head" :indeterminate="isIndeterminateCategory" @change="handleCheckAllCategory">全選</el-checkbox></span
        >
        <el-select v-model="submitData.serviceCategoryIds" value-key="id" multiple placeholder="請選擇" :popper-append-to-body="true">
          <el-option v-for="item in categoryList" :key="item.id" :label="item.categoryTitle" :value="item.id"> </el-option>
        </el-select>
      </el-form-item> -->



      <!-- 舊下拉，未來不用p3 -->
      <!-- <el-form-item label="可受理的服務項目" style="min-height:250px" :class="$style['services-wrap']" prop="productPriceIds">
        <el-checkbox
          v-if="availableService.length"
          v-model="checkAll"
          :indeterminate="isIndeterminate"
          style="margin-left: 5px; margin-top: 10px; margin-bottom: 5px"
          border
          @change="handleCheckAllChange"
          >全 選</el-checkbox
        >
        <el-alert v-else title="請選擇分店與寵物體型" type="warning" :closable="false"></el-alert>
        <el-checkbox-group v-model="submitData.productPriceIds" :class="$style.services">
          <el-checkbox v-for="service in availableService" :key="`free-${service.id}`" :label="service.id" border>
            <div class="content">
              <span v-if="service.state === 0" class="side-icon">已下架</span>
              <span class="title" style="font-size: 15px">{{ service.title }}</span>
              <span class="meta">
                <span style="font-size: 14px; margin-right: 10px">{{ service.location }}</span>
                <span>{{ service.categoryTitle }}</span>
              </span>
            </div>
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item> -->

<!-- </template> -->